import { Money } from 'types/entity/product';
import Price from './Price';

type Props = {
  price?: Money;
  locale: string;
};

const StrikePrice: React.FC<Props> = ({ price, locale }) => {
  return <Price locale={locale} price={price} className="text-gray-500 line-through" />;
};

export default StrikePrice;
